import Stock from '@/models/item/stock'
import DisplayRule from '@/models/item/stock/specification/display-rule'

export default class SoldOut implements DisplayRule {
  constructor(private readonly label: string) { }

  shouldApply(stock: Stock): boolean {
    // WEB在庫がない場合は購入できないので煽り在庫に関わらずsold outとする
    // 逆に、WEB在庫があれば煽り在庫に関わらず購入できるのでsold outではない
    return stock.web.isEmpty
  }
  apply(_: Stock): string {
    return this.label
  }
}
